import { CFormieFragments } from './c-formie'

export const CContactFormFragments = {
  field: `
    fragment contactForm on contactForm_MatrixField {
      ...on contactForm_block_Entry {
        idName
        heading
        subheading
        description
        bottomContent
        imageDesktop {
          title
          url
        }
        actions {
          ... on actions_Entry {
            actionType
            actionTitle
            actionValue
          }
        }
        formieHeading
        formie {
          ...FormieFormFragment
        }
        hiddenFormie {
          ...FormieFormFragment
        }
        successHeading
        successSubheading
        successButton {
          text
          url
        }
      }
    }
    ${CFormieFragments.field}
  `,
}
